/**
 * 단어 목록과 같이 표시되는 도움말 항목
 */
import {Component, HostBinding, ViewEncapsulation} from '@angular/core';

import {OPTION_TYPE, triggerCollapse} from '../../shared/defines/client.const';
import {api_url, api_url_replace} from '../../shared/defines/protocol';
import {Article} from '../../shared/models/article.model';
import {OPTION_ITEM, OptionService} from '../../shared/services/option/option.service';
import {BoardService} from '../../shared/services/board/board.service';
import {
  LIST_HELP_FLAG,
  LIST_HELP_ITEM,
  LIST_HELP_TYPE,
  ListHelpService
} from '../../shared/services/list-help/list-help.service';


@Component({
  selector: 'app-word-list-help',
  templateUrl: './word-list-help.component.html',
  styleUrls: ['./word-list-help.component.scss'],
  animations: [ triggerCollapse ],
  encapsulation: ViewEncapsulation.None,
})
export class WordListHelpComponent {
  @HostBinding('style.display') styleBlock = 'block';
  ApiUrl = api_url;
  ApiUrlReplace = api_url_replace;
  LIST_HELP_TYPE = LIST_HELP_TYPE;

  public selected: LIST_HELP_FLAG = null;
  public listHelp: Array<LIST_HELP_ITEM> = null;
  public articles: Map<LIST_HELP_FLAG, Article> = new Map<LIST_HELP_FLAG, Article>();

  constructor(
    private option: OptionService,
    private board: BoardService,
    private listHelpSvc: ListHelpService,
  ) {
    this.reset();
  }

  public reset(): void {
    this.listHelp = this.listHelpSvc.GetListHelp(null);

    // HELP(게시판)이면 로딩을 해서 articles에 넣는다.
    this.listHelp.filter((item: LIST_HELP_ITEM) => item.type === LIST_HELP_TYPE.HELP)
      .forEach((item: LIST_HELP_ITEM) => {
        this.board.GetDetail(item.content as number).subscribe(data => {
          this.articles.set(item.flag, new Article(data));
          console.log('WordListHelpComponent GetDetail=', data, this.articles);
        });
      });
  }

  GetOptionItem(type: OPTION_TYPE): OPTION_ITEM {
    return this.option.GetOptionItem(type);
  }

  public onSelectHelp(event: MouseEvent, item: LIST_HELP_ITEM): void {
    event.stopPropagation();
    event.preventDefault();
    if (this.selected === item.flag) {
      this.selected = null;
    }
    else {
      this.selected = item.flag;
    }
  }

  public onClose(item: LIST_HELP_ITEM, event: MouseEvent = null): void {
    console.log('onClose()', item);
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.listHelpSvc.SetFlag(item.flag);
    this.listHelp = this.listHelp.filter(v => v.flag !== item.flag);
  }
}
